import { FormLabel as CFormLabel, FormLabelProps } from '@chakra-ui/react';

const FormLabel: React.FC<FormLabelProps> = props => (
  <CFormLabel mb={1} {...props} />
);

export default FormLabel;
